import classnames from 'classnames';

function showCloseButtonClass(signinFieldValue) {
  return classnames({'input-close-button__show': signinFieldValue && signinFieldValue.length > 0});
}

function errorClass(errors={}, inputField) {
  return classnames({'error-input': errors[inputField] && errors[inputField].length > 0});
}

const clearInputContent = (e, fieldLabel, loginObj, errors, dispatch) => {
  dispatch({type: 'LOGIN', ...loginObj, [fieldLabel]: ""});
  dispatch({ type: 'ERRORS', ...errors, [fieldLabel]: ""});
  dispatch({type: 'API_ERRORS', apiErrors: {}});
}

export {
  showCloseButtonClass,
  errorClass,
  clearInputContent
}


// WEBPACK FOOTER //
// ./app/javascript/util/form_login_utils.js